__turbopack_context__.v({
  "eyebrow": "CloudSolutionsServicesCardSection-module__UZE6oq__eyebrow",
  "heading": "CloudSolutionsServicesCardSection-module__UZE6oq__heading",
  "section": "CloudSolutionsServicesCardSection-module__UZE6oq__section",
  "title": "CloudSolutionsServicesCardSection-module__UZE6oq__title",
});
